import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=9ae51aa2&scoped=true"
import script from "./aptitude.vue?vue&type=script&lang=js"
export * from "./aptitude.vue?vue&type=script&lang=js"
import style0 from "./aptitude.vue?vue&type=style&index=0&id=9ae51aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae51aa2",
  null
  
)

export default component.exports